export default [
  {
    path: '/profile/notifications',
    name: 'notifications',
    redirect: { name: 'notifications-tab-system', params: { tab: 'system' } },
    component: () => import(/* webpackChunkName: 'PageProfileNotifications' */ '../PageProfileNotifications'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'system',
        name: 'notifications-tab-system',
        params: { tab: 'system' },
      }, {
        path: 'updates',
        name: 'notifications-tab-updates',
        params: { tab: 'updates' },
      },
    ],
  },
];
